import type { IconData } from '@stacksjs/iconify-core'

export const codingAppsWebsitesMusicPlayer: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M30.48 1.53H32v28.95h-1.52ZM1.52 30.48h28.96V32H1.52Zm24.38-6.09h1.53v1.52H25.9ZM3.05 3.05v16.76h25.9V3.05Zm24.38 15.24H4.57V4.58h22.86Zm-3.05 7.62h1.52v1.52h-1.52Zm0-3.05h1.52v1.53h-1.52Z\"/><path fill=\"currentColor\" d=\"M24.38 12.19h1.52v-1.52h-1.52V9.15h-1.52v4.57h-1.53v1.52h3.05zm-3.05 10.67h1.53v4.57h-1.53ZM18.29 9.15h-1.53v1.52h3.05V6.1h-4.57v1.52h3.05zm-1.53 13.71h-1.52v-1.52h-1.53v7.62h1.53v-1.53h1.52v-1.52h1.53v-1.52h-1.53z\"/><path fill=\"currentColor\" d=\"M15.24 7.62h-1.53v3.05h-1.52v1.52h3.05zm-6.1 15.24h1.53v4.57H9.14Zm0-13.71H7.62v4.57H6.1v1.52h3.04zM6.1 25.91h1.52v1.52H6.1Zm0-3.05h1.52v1.53H6.1Zm-1.53 1.53H6.1v1.52H4.57ZM1.52 0h28.96v1.53H1.52ZM0 1.53h1.52v28.95H0Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default codingAppsWebsitesMusicPlayer
